<script setup>
import Icon from '@/components/Icon.vue';

const props = defineProps({
  id: { type: String, default: 'kids' },
  badge: { type: Object, required: true }, // { icon, label }
  title: { type: String, required: true },
  intro: { type: String, required: true },
  items: { type: Array, required: true }, // [{ icon, text }]
});
</script>

<template>
  <div :id="props.id" class="mb-20 scroll-mt-32">
    <div class="glass-card rounded-[2rem] p-8 sm:p-10 border border-[#1c4848]/5 shadow-[0_8px_30px_rgb(28,72,72,0.03)] relative overflow-hidden">
      <div class="absolute right-0 top-0 w-64 h-64 bg-blue-100/40 rounded-full blur-[80px] pointer-events-none"></div>

      <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50/50 border border-blue-100/50 mb-6">
        <Icon :icon="props.badge.icon" class="text-blue-500 text-sm" />
        <span class="text-xs font-medium text-blue-700 tracking-[0.2em] uppercase">
          {{ props.badge.label }}
        </span>
      </div>

      <h2 class="text-3xl font-serif text-[#1c4848] font-medium tracking-tighter mb-4">
        {{ props.title }}
      </h2>
      <p class="text-base text-[#1c4848]/60 font-normal leading-relaxed mb-8">
        {{ props.intro }}
      </p>

      <div class="space-y-4">
        <div
          v-for="(it, idx) in props.items"
          :key="idx"
          class="flex items-center gap-4 bg-white/50 p-4 rounded-xl border border-white"
        >
          <div class="w-8 h-8 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
            <Icon :icon="it.icon" class="text-base" />
          </div>
          <span class="text-[#1c4848] font-normal text-sm">{{ it.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

